import axios from "axios";
import {
  API_ERROR_MESSAGES,
  possibleErrorMessageTypes,
} from "./apiErrorMessages";
import { toastService } from "./toastService";

function getBackendErrorMessage(error) {
  if (!error?.response?.data) {
    return error?.message;
  }

  const data = error.response.data;
  if (typeof data === "string") {
    const trimmed = data.trim();
    if (trimmed === "") return error.message;

    const lines = trimmed.split(/\r?\n/);
    for (const line of lines) {
      const match = line.match(/(?:message|msg|error|err)\s*[:=]\s*(.+)/i);
      if (match && match[1]) return match[1].trim();
    }
    return trimmed;
  }

  if (typeof data === "object" && data !== null) {
    for (const prop of possibleErrorMessageTypes) {
      if (
        prop in data &&
        typeof data[prop] === "string" &&
        data[prop].trim() !== ""
      ) {
        return data[prop].trim();
      }
    }
  }

  return error.message;
}

const apiClient = axios.create({
  baseURL: "/api",
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

apiClient.interceptors.response.use(
  (response) => {
    console.log("checkRess", response);
    return response;
  },
  (error) => {
    // if (!error?.response) {
    //   console.error("Network Error:", error);
    //   toastService.error("Network error. Please check your connection.");
    //   return Promise.reject(error);
    // }

    // console.log("===", error);

    const status = error.response.status;
    const backendMessage = getBackendErrorMessage(error);

    switch (status) {
      case 400:
        console.warn("Bad Request:", backendMessage);
        toastService.error(backendMessage || API_ERROR_MESSAGES[400]);
        break;

      case 401:
        try {
          const current = window.location.pathname + window.location.search;
          localStorage.setItem("postLoginRedirect", current);
        } catch {}

        const path = window.location.pathname || "";
        if (!path.startsWith("/.auth") && !path.startsWith("/login")) {
          window.location.href = "/.auth/login/aad";
        }
        break;

      case 403:
        console.warn("Forbidden:", backendMessage);
        toastService.error(backendMessage || API_ERROR_MESSAGES[403]);
        break;

      case 404:
        console.warn("Not Found:", backendMessage);
        toastService.warning(backendMessage || API_ERROR_MESSAGES[404]);
        break;

      case 502:
        console.error("Bad Gateway:", backendMessage);
        toastService.error(backendMessage || API_ERROR_MESSAGES[502]);
        break;

      case 504:
        console.error("Gateway Timeout:", backendMessage);
        toastService.error(backendMessage || API_ERROR_MESSAGES[504]);
        break;

      case 500:
        console.error("Server Error:", backendMessage);
        toastService.error(backendMessage || API_ERROR_MESSAGES[500]);
        break;

      default:
        console.error("Unhandled Error:", backendMessage);
        toastService.error(backendMessage || "An unexpected error occurred");
    }

    return Promise.reject(error);
  }
);

export default apiClient;
